import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import DiscoveryArtworkCardView from "./DiscoveryArtworkCardView"
import { Skeleton } from 'antd';
import './CommonCardView.css';

var currentPage = 0;
var totalPage = 0;
const req = {
  method: 'GET',
  headers: { "X-Access-Token": "123456" },
};
const fetchArtworks = () => {
  return fetch(`http://192.168.1.140:8001/artworks?page=${currentPage}`,
    req)
    .then(res => {
      if (res.ok) {
        console.log("request successfully")
        return res.json()
      }
      throw new Error(`Error HTTP response`);
    })
    .then(data => {
      if (data.code === 200) {
        currentPage = data.result.currentPage
        totalPage = data.result.totalPage
        // console.log("item count")
        // console.log(data.result.data) // 2
        return data.result.data
      } else {
        throw new Error(`Error HTTP format`);
      }
    })
    .catch(error => console.log('error', error));
}

// function NextArrow(props) {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={className}
//       style={{ ...style, display: "block", background: "red" }}
//       onClick={onClick}
//     />
//   );
// }

// function PrevArrow(props) {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={className}
//       style={{ ...style, display: "block", background: "green" }}
//       onClick={onClick}
//     />
//   );
// }

const DiscoverySlick = (props) => {
  // const [artworks, setArtworks] = useState([]);

  // useEffect(() => {
  // fetchArtworks().then((data) => {
  //   setArtworks(data)
  // })
  // }, [])

  var sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    nextArrow: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.32977 36.6463C0.353459 37.6226 0.353459 39.2055 1.32977 40.1818C2.30608 41.1581 3.88899 41.1581 4.8653 40.1818L14.4377 30.6094L24.0101 21.0371L23.9733 21.0003L24.1172 20.8564L4.97243 1.71161C3.99612 0.735296 2.41321 0.735296 1.4369 1.71161C0.460586 2.68792 0.460586 4.27083 1.4369 5.24714L17.0829 20.8932L10.9022 27.0739L1.32977 36.6463Z" fill="#0E487A" />
    </svg>,
    prevArrow: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.6761 36.6463C24.6524 37.6226 24.6524 39.2055 23.6761 40.1818C22.6998 41.1581 21.1169 41.1581 20.1406 40.1818L10.5682 30.6094L0.995795 21.0371L1.03258 21.0003L0.88867 20.8564L20.0334 1.71161C21.0097 0.735296 22.5927 0.735296 23.569 1.71161C24.5453 2.68792 24.5453 4.27083 23.569 5.24714L7.92295 20.8932L14.1037 27.0739L23.6761 36.6463Z" fill="#0E487A" />
    </svg>,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
          breakpoint: 1000,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      }
    ]
  };
  return (
    <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
      <p className='collection-title'> Artworks </p>

      {/* {artworks.length === 0 && (
        <Skeleton active />
      )} */}
      {props.artworks.length !== 0 && (
        <Slider {...sliderSettings}>
          {props.artworks.map((item, index) => (
            <div key={index}>
              <DiscoveryArtworkCardView item={item} />
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
}

export default DiscoverySlick;
